/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'
import vessels from './modules/vessels'
import reparations from './modules/reparations'
import resignations from './modules/resignations'
import address from './modules/address'
import refinery from './modules/refinery'
import oilTransfer from './modules/oilTransfer'
import users from './modules/users'
import accessories from './modules/accessories'
import monitoring from './modules/monitoring'
import notifications from './modules/notifications'
import mpTankerData from './modules/mpTankerData'
import rts from './modules/rts'
import installAccessories from './modules/installAccessories'

//pdss
import tracker from "./modules/tracker";
import vesselTanker from "./modules/vesselTanker";
import tankerData from "./modules/tankerData";
import radarData from "./modules/radarData"
import lineData from "./modules/lineData"
import greenDieselCardActive from "./modules/greenDieselCardActive"
import vesselTrip from "./modules/vesselTrip"
// import mpTankerData from './modules/mpTankerData'
import mpVesselData from "./modules/mpVesselData"
import mpTransferData from "./modules/mpTransferData"
// 
import mpProvinces from './modules/mpProvinces'
// 
import profile from "./modules/profile";
import oilPrice from "./modules/oilPrice";
import priceOilType from "./modules/priceOilType";

//mpTankerDataPDSS
import mpTankerDataPDSS from "./modules/mpTankerDataPDSS";

//petrol
import petrol from './modules/petrol'

//flowMeter
import flowMeter from './modules/flowMeter'






export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      auth: moduleAuth,
      vessels,
      reparations,
      resignations,
      address,
      oilTransfer,
      refinery,
      users,
      accessories,
      monitoring,
      notifications,
      mpTankerData,
      rts,
      installAccessories,

      //pdss
      tracker,
      vesselTanker,
      tankerData,
      radarData,
      lineData,
      greenDieselCardActive,
      vesselTrip,
      mpVesselData,
      mpTransferData,
      mpProvinces,
      profile,
      oilPrice,
      priceOilType,
      mpTankerDataPDSS,

      //petrol
      petrol,

      //flowMeter
      flowMeter

    },
    strict: process.env.NODE_ENV !== 'production'
})
